import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import './css/style.scss';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';
SwiperCore.use([EffectFade, Autoplay]);
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { log, reactHtmlParser } from '../../../../common/common';
import axios from 'axios';
import appConfig from '../../../../config/config';
import { authHeader } from '../../../../Store/helper/authHeader';
import { Fade } from 'react-reveal';
import ShareCard from '../../../ShareCard';
import { CLICK_SUBMIT_POLL } from '../../../../TrackerFolder/constants/ActionType';
import { onSubmitPoll } from '../../../../TrackerFolder/actions/dashboardActions';
import axiosInstance from '../../../../Store/helper/axiosInstance';
import { useTracker } from '../../../../TrackerFolder/TrackerComponent';
import LazyImage from '../../../CustomLibraries/LazyImage';
// import ShowMoreText from '../../../showMoreText/ShowMoreText';
import ShowMoreText from 'react-show-more-text';

import ModalDoctorVoice from '../../../../pages/dashboard/components/ModalDoctorVoice';
import { useTrackUserActivity } from '../../../customHooks/useTrackUserActivity';
import InView from 'react-intersection-observer';
// install Swiper modules

const url = appConfig.apiLoc;

const PollCardV1 = ({
  data,
  noShare = false,
  isCme = false,
  setJustAnswered,
  click,
  type = '',
  onCompletePoll,
  isChannel = false,
  gtmTagVariable = ''
}) => {
  console.log('++>>', data);
  const pollCardRef = useRef(null);
  let sponsorLogo = isChannel
    ? data?.sponsor_names_and_logos?.map((_) => _.client_logo)
    : data?.sponsor_logo
    ? data?.sponsor_logo.split(',')
    : [];
  const [currOptions, setCurrOptions] = useState({});
  const [ansGiven, setAnsGiven] = useState(false);
  const [toOpenModal, setToOpenModal] = useState(false);
  const { trackActivityEvent } = useTracker();
  const [show, setShow] = useState(false);
  const handleShow = useCallback(() => setShow(true), [show]);
  const [truncated, setTruncated] = useState(false);
  const handleClose = useCallback(() => {
    setShow(false);
  }, [show, currOptions, ansGiven]);
  if (data && data.json_data && data.json_data != 'false') {
    // console.log('++>>', data);
    var parsedData = JSON.parse(unescape(data.json_data));
    var qArray = Object.keys(parsedData?.surveys).map((k) => {
      return parsedData.surveys[k];
    });
    var { question, options } = qArray[0];
    // console.log('++++>>>>>QUESTION ARRAY', qArray);
  } else if (data && data.data_json) {
    console.log('++>>', data);
    var parsedData = JSON.parse(unescape(data.data_json));
    var qArray = Object.keys(parsedData?.surveys).map((k) => {
      return parsedData.surveys[k];
    });
    var { question, options } = qArray[0];
    // console.log('++++>>>>>QUESTION ARRAY', qArray);
  }
  const triggerModalClose = (currOptions) => {
    setAnsGiven(true);
    setCurrOptions(currOptions);
  };
  useEffect(() => {
    setCurrOptions(options);
  }, []);
  const onPollSubmit = (selectedIndex, id) => {
    if (truncated) {
      handleShow();
    } else {
      typeof trackActivityEvent == 'function' &&
        trackActivityEvent(CLICK_SUBMIT_POLL, onSubmitPoll(id, options[selectedIndex]));
      if (qArray[0]) {
        qArray[0].selectedIndex = selectedIndex;
      }
      axiosInstance
        .post(isCme ? 'survey/pollAnswercme' : 'survey/pollAnswer', {
          answer_json: JSON.stringify(qArray),
          survey_id: data.survey_id
        })
        .then((res) => {
          if (!isCme) {
            axiosInstance
              .get(`survey/pollResult?id=${data.survey_id}`)
              .then((response) => {
                log('Poll result', JSON.parse(response.data.data)[0].options);
                setCurrOptions(JSON.parse(response.data.data)[0]);
                setAnsGiven(true);
                axiosInstance
                  .post('survey/addpoint', {
                    point: data.point || data?.survey_points,
                    survey_id: data.survey_id
                  })
                  .then((resp) => {
                    toast.success(`You have got ${data.point || data?.survey_points} points`);
                    onCompletePoll && onCompletePoll();
                  })
                  .catch((e) => {
                    log('Error', e);
                  });
              })
              .catch((e) => {
                log('Error', e);
              });
          } else {
            log('POST RESP', res);
            setJustAnswered(true);
            // toast.success(`Thank you for submitting the poll`);
          }
        })
        .catch((e) => {
          log('Error', e);
        });
    }
  };

  const { userActivityTracker } = useTrackUserActivity();
  return (
    <InView
      as="div"
      onChange={(inView) => {
        userActivityTracker(inView, { type: 'survey', ...data }, 'card');
      }}
    >
      <div className="w-100 float-start pollCardV1Box shadow rounded-3 bg-white position-relative overflow-hidden p-3 p-md-4">
        <span
          className="graph-1 position-absolute start-0 bottom-0"
          style={{ backgroundColor: '#28ca5a' }}
        ></span>
        <span
          className="graph-2 position-absolute start-0 bottom-0"
          style={{ backgroundColor: '#28ca5a' }}
        ></span>

        <div className="w-100 float-start pollCrdV1Btm">
          <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative mb-2">
            {/* <span className="crdV1topPartGraph position-absolute h-100 start-0 top-50 translate-middle-y" style={{ backgroundColor: "#28ca5a" }}></span> */}
            <h4 className="text-black rounded fs-4 pollCardV1Point py-2 px-3 border border-dark">
              <span className="fw-bold">{data.point || data?.survey_points}</span> Points
            </h4>
            {!noShare && (
              <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
                <ShareCard
                  gtmTagVariable={`gtm_cl_pollCard_share`}
                  className={`${gtmTagVariable}_pollCard_share`}
                  data={{ title: data?.survey_title, url: data?.deeplink }}
                  // id={`${gtmTagVariable}_${data?.survey_title}`}
                />
              </a>
            )}
          </div>
          <div className="w-100 float-start d-flex text-start cardV1Topic mb-2" ref={pollCardRef}>
            {/* withChanel */}
            {/* <div className="rounded-circle cardV1ProfilePic overflow-hidden d-flex justify-content-center align-items-center border border-light">
            <img src="https://cdn1.vectorstock.com/i/1000x1000/74/45/line-letter-m-square-logo-design-inspiration-vector-26437445.jpg" />
          </div> */}
            {/* withChanel */}

            <div className="cardV1TopicContent position-relative w-100">
              <ShowMoreText
                anchorClass={'show-more-less-clickable cursorPointer'}
                lines={4}
                expandByClick={false}
                onClick={handleShow}
                more={toOpenModal ? '...' : 'Show More'}
                less={toOpenModal ? '...' : 'Show Less'}
                className="text-black fs-16 fw-medium"
                // keepNewLines={false}
                width={pollCardRef?.current?.clientWidth}
              >
                {reactHtmlParser(question) ?? ''}
              </ShowMoreText>
            </div>
          </div>
          <div className="w-100 float-start cardV1Ftr mt-2">
            {!ansGiven ? (
              <Form>
                {options &&
                  options.map((_opt, _idx) => (
                    <Form.Check
                      key={_opt.value}
                      className="pollCardV1Radio fs-4 p-0 mb-3 position-relative cursorPointer"
                      label={
                        <ShowMoreText
                          anchorClass={'show-more-less-clickable'}
                          lines={4}
                          expandByClick={false}
                          onClick={() => onPollSubmit(_opt.value, data.survey_id)}
                          more={toOpenModal ? '...' : '...'}
                          less={toOpenModal ? '...' : '...'}
                          className="text-black fs-16 fw-medium"
                          truncatedEndingComponent=""
                          onTruncate={() => {
                            if (!truncated) {
                              setTruncated(true);
                            }
                          }}
                        >
                          {console.log('++>>', _opt.label)}
                          {_opt?.label ?? ''}
                        </ShowMoreText>
                      }
                      name={`${_idx}group${data.survey_id}`}
                      type="radio"
                      id={'poll' + data.survey_id + _opt.value}
                      onChange={() => {
                        if (type == 'cta') {
                          click && click();
                          onPollSubmit(_opt.value, data.survey_id);
                        } else {
                          click ? click() : onPollSubmit(_opt.value, data.survey_id);
                        }
                      }}
                    />
                  ))}
              </Form>
            ) : (
              <></>
            )}
            {ansGiven ? (
              <Fade bottom>
                <div className="w-100 float-start pollCardV1Ansr">
                  {currOptions.options.map((_option, index) => (
                    <div className="pollCardV1AnsrRow position-relative mb-3" key={index + 1}>
                      <ProgressBar now={_option.vote} />
                      <div
                        className={`pollCardV1AnsrRowIn py-4 position-relative z-2 text-start ${
                          currOptions.selectedIndex == _option.value ? 'text-primary' : 'text-black'
                        } `}
                      >
                        {_option.label}
                        <span className="position-absolute">{_option.vote}%</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Fade>
            ) : (
              <></>
            )}
            {/* sponser logo if single */}
            {sponsorLogo.length == 1 && (
              <div className="crdV1sponser mt-4 text-end float-end">
                <div className="crdV1sponserIn bg-white d-inline-flex justify-content-end align-items-center">
                  <LazyImage src={sponsorLogo[0]} className="float-end" alt="sponsor_logo" logo />
                </div>
              </div>
            )}
            {/* sponser logo if multiple */}
            {sponsorLogo.length > 1 && (
              <Swiper
                className="crdV1sponser mt-4 text-end float-end"
                navigation={false}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                autoplay={{
                  delay: 2500
                }}
                effect={'fade'}
              >
                {sponsorLogo.map((logo, _i) => (
                  <SwiperSlide
                    className="crdV1sponserIn bg-white d-inline-flex justify-content-end align-items-center"
                    key={_i + 1}
                  >
                    <LazyImage src={logo} className="float-end" logo />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            {/* sponser logo if multiple */}
          </div>
        </div>
      </div>
      <ModalDoctorVoice
        show={show}
        data={{ ...data, json_data: data?.json_data || data?.data_json }}
        handleClose={handleClose}
        triggerModalClose={(currOptions) => triggerModalClose(currOptions)}
        headingText="Poll"
      />
    </InView>
  );
};
export default memo(PollCardV1);
